import type { IFlightScheduleChangeModalData } from "@tenant/flights";
import { Loading } from "@tenant/ui";

export interface IFlightScheduleChangeProcessingProps {
  classNames?: Partial<{
    contentBody: string;
    processingMessage: string;
    processingSpinner: string;
    root: string;
  }>;
  text: IFlightScheduleChangeModalData["text"];
}

export const FlightScheduleChangeProcessing = (
  props: IFlightScheduleChangeProcessingProps
) => {
  const { classNames, text } = props;

  return (
    <div className={classNames?.root}>
      <div className={classNames?.contentBody}>
        <Loading className={classNames?.processingSpinner} />
        <span className={classNames?.processingMessage}>
          {text.processing.title}
        </span>
      </div>
    </div>
  );
};
